import React, { Component } from 'react';
import PropType from 'prop-types';
import { StyledIconContainer, StyledIconSizing } from './SVGIcon.styles';

/** Icon imports */
import Calendar from './icons/Calendar';
import Pencil from './icons/Pencil';
import ClearSearch from './icons/ClearSearch';

/** Add SVG Icons here */
const iconIndex = props => ({
  calendar: <Calendar {...props} />,
  pencil: <Pencil {...props} />,
  clearSearch: <ClearSearch {...props} />
});

export const iconIndexKeys = Object.keys(iconIndex(null));

export default class CustomerSVGIcon extends Component {
  static propTypes = {
    /**
     * The Selected SVG Icon
     */
    selectedIcon: PropType.string.isRequired,

    /**
     * Selected background color, all SVGs have a default color related to their branding
     */
    backgroundColor: PropType.string,

    /**
     * The height of the Icon if different from the default - including unit (px, % etc.)
     */
    height: PropType.string,

    /**
     * The width of the Icon if different from the default - including unit (px, % etc.)
     */
    width: PropType.string,

    /**
     * The Icons color, most default to white
     */
    iconColor: PropType.string,

    /**
     * Rotation of the Icon, passed as a number between 0-360
     */
    rotate: PropType.number,

    /**
     * Option to take in a click function on the SVG
     */
    onClick: PropType.func,
    /**
     * Add ability to override in .styles.js file
     */
    className: PropType.string,

    /**
     * Option to take in a diable function on the SVG
     */
    disabled: PropType.bool,
  };

  static defaultProps = {
    backgroundColor: undefined,
    height: undefined,
    width: undefined,
    iconColor: undefined,
    rotate: 0,
    onClick: undefined,
    className: null,
    disabled: false,
  };

  render() {
    const { selectedIcon, height, width, rotate, className, onClick, ...props } = this.props;
    const icon = iconIndex(props)[selectedIcon];

    let iconWidth;
    let iconHeight;
    let iconPadding;
    if (icon) {
      iconPadding =
        (icon.props.width && icon.props.height) !== undefined ? (icon.props.height / icon.props.width) * 100 : 100;
      iconWidth = icon.props.width !== undefined ? `${icon.props.width}px` : '';
      iconHeight = icon.props.height !== undefined ? `${icon.props.height}px` : '';
    }

    // overrides the icon padding based on the passed props for height and width if both are passed.
    if (height && width) iconPadding = (height.replace('px', '') / width.replace('px', '')) * 100;

    // overrides the height to auto if a percent is passed to the width
    const heightAuto = width ? width.indexOf('%') > -1 : false;

    return (
      <StyledIconSizing
        width={!width ? `${iconWidth}` : width}
        height={!height ? `${iconHeight}` : height}
        className={className}
        heightAuto={heightAuto}
        disabled={this.props.disabled}
        onClick={onClick}
      >
        <StyledIconContainer rotate={rotate} iconPadding={iconPadding}>
          {icon || null}
        </StyledIconContainer>
      </StyledIconSizing>
    );
  }
}
